module.exports = __webpack_public_path__ + "static/@PLaYArena-b9a7b42f5ca32a31f28aa38f5584e549.webp";